<template>
    <div v-loading.fullscreen="loading">
        <div v-if="!loading">
            <el-breadcrumb
                v-if="hasRoleToReadLogs"
                style="float: right"
                separator-class="el-icon-arrow-right"
            >
                <el-breadcrumb-item :to="{ path: '/' }">{{$t('route.home')}}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'tournamentList' }">{{$t('entities.tournament.plural')}}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ model.name }}</el-breadcrumb-item>

            </el-breadcrumb>

            <h2 class="page-title">{{$t('entities.tournament.settingGroups.title')}}</h2>
            <h4 class="page-title">{{$t('entities.tournament.settingGroups.description')}}</h4>

            <el-row :gutter="20">
            <!----------->
            <template>
                <el-tabs type="border-card" tab-position="top" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane
                    v-for="(item, index) in options.categories"
                    :key="item.id"
                    :label="item.label"
                    :name="item.id"
                >
                    <!-- {{item.label}} -->
                    <!-- <setting-groups :categoryId="item.id"/> -->
                </el-tab-pane>
                <transition name="fade" mode="out-in">
                    <router-view></router-view>
                </transition>
                </el-tabs>
            </template>
            </el-row>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SettingGroups from "@/entities/tournament/setting-groups/setting-groups";
/* eslint-disable */
export default {
    name: "app-tournament-show",

    components: {
        settingGroups: SettingGroups
    },

    props: {
        id: String
    },

    data() {
        return {
            activeName: 'first'
        }
    },
    created() {
        // this.$store
        //     .dispatch("entities/tournament/detail", this.id)
        //     .catch(() => this.$router.push({ name: "tournamentList" }));
        this.$store.dispatch('entities/tournament/loadOptions')
        this.$store.dispatch("entities/tournament/listTeams");

       // this.$router.push({ name: "settingGroups" })
    },

    beforeRouteLeave(to, from, next) {
       // this.$store.dispatch("entities/tournament/clear");
        next();
    },

    computed: {
        ...mapGetters({
            model: "entities/tournament/model",
            loading: "entities/tournament/loading",
            hasRoleToDelete: "entities/tournament/hasRoleToDelete",
            hasRoleToUpdate: "entities/tournament/hasRoleToUpdate",
            hasRoleToRead: "entities/tournament/hasRoleToRead",
            hasRoleToReadLogs: "entities/tournament/hasRoleToReadLogs",
            hasRoleToCreate: "entities/tournament/hasRoleToCreate",
            isMobile: "shared/isMobile",
            labelPosition: "shared/labelPosition",
            labelWidth: "shared/labelWidth",
            options: 'entities/tournament/options',
            teamList: "entities/tournament/teamList",
        })
    },

    methods: {
        edit() {
            this.$router.push({
                name: "tournamentEdit",
                params: { id: this.id, previous: "show" }
            });
        },

        destroy() {
            this.$confirm("Are you sure?", "Confirm", {
                confirmButtonText: "Yes",
                cancelButtonText: "No",
                type: "warning"
            })
                .then(() =>
                    this.$store.dispatch("entities/tournament/destroy", this.model)
                )
                .then(() => this.$router.go(-1))
                .catch(() => {});
        },
        handleClick(tab, event) {
                // // 1.1 Cargamos los equipos por categoria
                // this.$store.dispatch("entities/tournament/settingGroups/listTeamsByCategoryId", tab.name)
                // // 1.2 Cargamos los grupos por categoria
                // this.$store.dispatch("entities/tournament/settingGroups/listGroup", tab.name)

                // 2. Mostramos la vista
                this.$router.push({
                name: "settingGroups",
                params: { categoryId: tab.name}
            });
        },

        history() {
            this.$router.push({
                name: "tournamentHistorySingle",
                params: { id: this.id }
            });
        }
    }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/entities/tournament/tournament-settings.vue?13c4aa80